<template>
  <div>
    <button @click="addNewData">Ekle</button>
    <ul>
      <transition-group name="slide">
        <li
          v-for="(number, index) in numberList"
          class="list"
          :key="number"
          @click="removeData(index)"
        >
          {{ number }}
        </li>
      </transition-group>
    </ul>
  </div>
</template>

<script>
export default {
  name: "transition-group-example",
  data() {
    return {
      numberList: [1, 2, 3, 4, 5],
    };
  },
  methods: {
    addNewData() {
      const position = Math.floor(Math.random() * this.numberList.length);
      this.numberList.splice(position, 0, this.numberList.length + 1);
    },
    removeData(index) {
      this.numberList.splice(index, 1);
    },
  },
};
</script>

<style scoped>
button {
  margin: 20px 50px;
  background-color: wheat;
  color: green;
  font-size: 14px;
  padding: 15px;
  outline: none;
  border-radius: 5px;
  cursor: pointer;
}

ul {
  list-style: none !important;
}
.list {
  margin: 5px 0;
  list-style: none !important;
  background-color: #a97719;
  border: 1px solid gray;
  padding: 15px 25px;
  width: 100px;
}

.slide-enter {
  opacity: 0;
}
.slide-enter-active {
  animation: slide-in 1s ease-out forwards;
  transition: opacity 0.5s;
}

.slide-leave-active {
  animation: slide-out 1s ease-out forwards;
  transition: opacity 1s;
  opacity: 0;
  position: absolute;
}
.slide-move {
  transition: transform 1s;
}

@keyframes slide-in {
  from {
    transform: translateY(20px);
  }
  to {
    transform: translateY(0px);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(20px);
  }
}
</style>